import { useLingui } from "@lingui/react";
import { useBookingContext } from "@/contexts/BookingContext";
import { formatCurrency } from "@/utils/pricing";

export function useFormatPrice() {
  const { state } = useBookingContext();
  const { i18n } = useLingui();
  const price = state.price;

  const formatPrice = (value: number) =>
    price ? formatCurrency(value, price.currency, i18n.locale) : null;
  const formatPriceAlt = (value: number) =>
    price?.currency_alt ? formatCurrency(value, price.currency_alt.currency, i18n.locale) : null;

  return { formatPrice, formatPriceAlt };
}
